import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts"

const COLORS = ["#004877", "#bfdbfe"]

const GenderPieChart = ({ data }) => {
  // ✅ Filter out 0-count values
  const filteredData = data.filter((d) => d.count !== 0)

  // ✅ Custom label function → shows percentage inside slices
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const radius = innerRadius + (outerRadius - innerRadius) / 2
    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180))
    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180))

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={10}
        fontWeight="bold"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    )
  }

  return (
    <div className="flex flex-col items-center w-full h-full">
      <ResponsiveContainer width="100%" height="80%">
        <PieChart>
          <Pie
            data={filteredData}
            dataKey="count"
            nameKey="gender"
            cx="50%"
            cy="50%"
            outerRadius={40}
            labelLine={false}
            label={renderCustomizedLabel} // ✅ show % inside
          >
            {filteredData.map((entry, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      {/* ✅ Custom legend below the chart */}
      <div className="flex gap-4 mt-2 text-xs text-black">
        {filteredData.map((entry, i) => (
          <div key={entry.gender} className="flex items-center gap-1">
            <span
              className="inline-block w-3 h-3 rounded-full"
              style={{ backgroundColor: COLORS[i % COLORS.length] }}
            />
            <span className="capitalize">{entry.gender}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default GenderPieChart
